import "./presets_main.css";
import { useEffect, useState } from "react";
import P1 from "../assets/suits/product-1.jpg";
import P2 from "../assets/suits/uniform.jpg";
import P3 from "../assets/suits/pant_shirt.jpg";
import { PreFilter } from "../Data";
import { Sample_preset } from "../Data";
import mbg from "../assets/mbg1.jpg";
import { useNavigate, useParams } from "react-router-dom";
import { getData, getDataFromCollection } from "../Firebase/firestoreGet";
import { db } from "../firebase";
import P_card from "./preset-card";
import arrow from '../assets/Arrow/arrow_right.svg'

import aim from '../assets/samples/anima.gif'

import banner_suit from '../assets/Banner/banner_suit.jpg'
import banner_kurta from '../assets/Banner/banner_kurta.jpg'
import banner_formal from '../assets/Banner/formal_banner.jpg'
import { color } from "framer-motion";
import MetaTags from "../meta";
import { tags } from "../Data/metaTags";
import Filters from "../Filters";
import { getPresetFilters } from "../Functions";

// Category color map for distinct sections
const categoryColors = {
  kurta: 'category-section--kurta',
  suit: 'category-section--suit',
  formal: 'category-section--formal',
  blazer: 'category-section--blazer',
  sadri: 'category-section--sadri',
};

// SVG arrow icons for pagination
const ArrowLeft = () => (
  <svg className="arrow-left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" />
  </svg>
);
const ArrowRight = () => (
  <svg className="arrow-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
  </svg>
);

function Presets_main() {
  const navigate = useNavigate();

  const { cloth } = useParams()

  const [presets, setPresets] = useState()

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(20);

  const [currentPosts, setCurrrentPosts] = useState()

  const [filterOptions, setFilterOptions] = useState();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 480);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 480);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const [pages, setPages] = useState([])

  const getPresets = async () => {
    try {

      const collection = db.collection("Presets")

      const Data = await getData(collection)

      return Data;
    } catch (e) {
      console.log(e)
    }
  }
  useEffect(() => {

    getPresets().then((data) => {
      const lastPostIndex = currentPage * postsPerPage;
      const firstPostIndex = lastPostIndex - postsPerPage;

      let D = {}
      data.forEach((val) => {
        // "suit", "kurta", "pant", "shirt", "blazer", "formal", "sadri"
        const val11 = val.category === "shirt" || val.category === "pant" ? "formal" : val.category ? val.category : "suit"

        if (cloth && val11 !== cloth) {
          return
        }
        if (D[val11]) {
          D[val11].push(val)
        } else {
          D[val11] = [{ ...val }]
        }
      })
      setPresets(D)
      setCurrrentPosts(D)
      setFilterOptions(getPresetFilters(D))

    })
  }, [cloth])

  const banner = {
    kurta: {
      title: "Crafted for Your Every Moment",
      des: "Experience the perfect blend of tradition and personal style.",
      img: banner_kurta,
      style: { color: "black" }
    },
    suit: {
      title: "Power Dressing, Perfected",
      des: "Tailored suits that command attention and respect.",
      img: banner_suit,
      style: { color: "white" }
    },
    formal: {
      title: "Elegance in Every Stitch",
      des: "Custom formalwear designed to leave a lasting impression.",
      img: banner_formal,
      style: { color: "white" }
    },
  }

  const [T, setT] = useState()
  useEffect(() => {
    if (!cloth) {
      setT(tags.products)
    } else {
      setT(tags[`products_${cloth}`])
    }
  }, [cloth])

  return (
    <div className="presets_main">

      {T && <MetaTags data={T} />}

      {/* ===== Category-specific banner (when /products/:cloth) ===== */}
      {cloth && <div className="preset_main_banner"
        style={{ backgroundImage: `url(${banner[cloth].img})`, color: banner[cloth].style.color }}
      >
        <div className="preset_banner_des FIT_W FIT_H verti_center">
          <div className="title-font1 FIT_W" style={{ fontWeight: "bold" }}>{tags[`products_${cloth}`].h1}</div>
          <p className="txt-font1 FIT_W">{tags[`products_${cloth}`].p}</p>
        </div>
      </div>}

      {/* ===== Hero Section (when no category selected) ===== */}
      {!cloth && (
        <div className="products-hero">
          <div className="products-hero-particles">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="products-hero-particle" />
            ))}
          </div>
          <div className="products-hero-content">
            <span className="products-hero-badge">Designer's Exclusive</span>
            <h1 className="products-hero-title">
              Maviinci Exclusive Men's Collection
            </h1>
            <p className="products-hero-desc">
              Explore our exclusive collection of custom suits, kurtas, shirts, pants, and blazers — all designed to fit your style and your life. Choose from premium fabrics, modern cuts, and timeless designs.
            </p>
          </div>
        </div>
      )}

      {/* ===== Filters ===== */}
      <Filters
        filterOptions={filterOptions}
        data={presets}
        setCurrrentPosts={setCurrrentPosts}
        currentPosts={currentPosts}
      />

      {/* ===== Product Listings by Category ===== */}
      {currentPosts && Object.keys(currentPosts).map((val, key) => {
        const colorClass = categoryColors[val] || 'category-section--suit';
        return (
          <div key={key} className={`category-section ${colorClass}`}>
            {/* Category Header */}
            <div className="category-header">
              <h2 className="category-header-title">
                {val[0].toUpperCase() + val.slice(1)}
              </h2>
              <div className="category-header-line"></div>
              <button
                className="category-header-link"
                onClick={() => navigate(`/products/${val}`)}
              >
                Explore More
              </button>
            </div>

            {/* Products Grid */}
            <div className="products-grid">
              {currentPosts[val].length > 0 && currentPosts[val].map((pitem, idx) => (
                <P_card key={idx} item={pitem} />
              ))}
            </div>
          </div>
        )
      })}

      {/* ===== Loading State ===== */}
      {(!currentPosts) &&
        <div className="presets_loading" >
          <div style={{ textAlign: "center" }}>
            <img alt="" src={aim} onerror="this.src='https://d1fufvy4xao6k9.cloudfront.net/images/garment/loading.gif'" />
            <div>Loading Presets ...</div>
          </div>
        </div>
      }

      {/* ===== Pagination ===== */}
      {pages && pages.length > 0 && (
        <div className="products-pagination-container">
          <button
            className={`products-pagination-btn ${currentPage <= 1 ? 'products-pagination-btn--disabled' : ''}`}
            onClick={() => {
              if (currentPage > 1) {
                setCurrentPage(currentPage - 1);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }}
          >
            <ArrowLeft />
            Previous
          </button>

          <div className="products-pagination-pages">
            {pages.map((page, index) => (
              <button
                key={index}
                className={`products-pagination-page ${page === currentPage ? 'products-pagination-page--active' : ''}`}
                onClick={() => {
                  setCurrentPage(page);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
              >
                {page}
              </button>
            ))}
          </div>

          <button
            className={`products-pagination-btn ${currentPage >= pages.length ? 'products-pagination-btn--disabled' : ''}`}
            onClick={() => {
              if (currentPage < pages.length) {
                setCurrentPage(currentPage + 1);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }}
          >
            Next
            <ArrowRight />
          </button>
        </div>
      )}

    </div>
  );
}

export default Presets_main;
